import AddNew from "./AddNew";
import List from "./List";

export default function Cars() {
    return (
        <>
        <AddNew/>
        <List/>
        </>
    )
}